import React from 'react';
import { StyleSheet, ScrollView, View, TouchableOpacity, Text } from 'react-native';
import FieldOrderingBoard from '../../components/fieldOrdering/FieldOrderingBoard.web';
import theme from '../../config/theme';
import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import { FieldOrderingLogger } from '../../utils/logger';
import { MaterialCommunityIcons } from '@expo/vector-icons';

export default function FieldOrderingScreen() {
  const params = useLocalSearchParams<{ templateId?: string }>();
  const templateId = params.templateId as string | undefined;
  const router = useRouter();

  FieldOrderingLogger.Main.info('[FIELD-ORDERING.WEB] Render com templateId=' + templateId);

  return (
    <ScrollView style={styles.container} contentContainerStyle={styles.content}>
      <Stack.Screen options={{ headerShown: false }} />

      {/* Header customizado */}
      <View style={styles.header}>
        <TouchableOpacity style={styles.backButton} onPress={() => router.back()}>
          <MaterialCommunityIcons name="arrow-left" size={24} color={theme.colors.text.inverse} />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Ordenar Campos</Text>
        <View style={{ width: 40 }} />
      </View>

      <FieldOrderingBoard templateId={templateId} />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background.secondary,
  },
  content: {
    //paddingVertical: theme.spacing.md,
  },
  header: {
    backgroundColor: theme.colors.primary.default,
    padding: theme.spacing.lg,
    flexDirection: 'row',
    alignItems: 'center',
  },
  backButton: {
    width: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerTitle: {
    flex: 1,
    fontSize: theme.fontSizes.xl,
    color: theme.colors.text.inverse,
    fontWeight: theme.fontWeights.bold as any,
    textAlign: 'center',
  },
}); 